import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2, UIHeading2 } from '@cian/ui-kit';
import { ITableProps } from './types';
import * as styles from './styles.css';

export const Table: React.FC<ITableProps> = ({ title, elements }) => {
  return (
    <div className={styles['root']}>
      <UIHeading2>{title}</UIHeading2>
      <div className={styles['wrapper']}>
        <div className={styles['table']}>
          <div className={styles['row']}>
            <div className={styles['cell']}>
              <ArticleHeading4>Программа</ArticleHeading4>
            </div>
            <div className={styles['cell']}>
              <ArticleHeading4>Ставка</ArticleHeading4>
            </div>
            <div className={styles['cell']}>
              <ArticleHeading4>Кто может получить</ArticleHeading4>
            </div>
            <div className={styles['cell']}>
              <ArticleHeading4>На что дают кредит</ArticleHeading4>
            </div>
            <div className={styles['cell']}>
              <ArticleHeading4>Условия</ArticleHeading4>
            </div>
          </div>
          {elements.map((program, index) => (
            <div className={styles['row']} key={index}>
              <div className={styles['cell']}>
                <ArticleParagraph2>{program.name}</ArticleParagraph2>
              </div>
              <div className={styles['cell']}>
                <ArticleParagraph2>{program.rate}</ArticleParagraph2>
              </div>
              <div className={styles['cell']}>
                <ArticleParagraph2>{program.whoCanGet}</ArticleParagraph2>
              </div>
              <div className={styles['cell']}>
                <ArticleParagraph2>{program.creditFor}</ArticleParagraph2>
              </div>
              <div className={styles['cell']}>
                <ArticleParagraph2>{program.conditions}</ArticleParagraph2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
